import React from 'react'

function LeftImage({url=''}) {
  return (
    <div className={` relative flex justify-start items-center  pb-[30px]`}>
        <div className='w-[300px] h-[300px] max-[950px]:w-[200px] max-[950px]:h-[200px] absolute top-0 left-0 justify-center items-center bg-[--red]'>
        </div>
        <div>
        <img className='w-[425px] min-h-[423px] max-[1000px]:w-[400px] max-[1000px]:min-h-[400px] max-[950px]:w-[350px] max-[950px]:min-h-[350px] h-auto relative max-[950px]:top-[20px] max-[950px]:left-[20px] top-[30px] left-[30px] max-[830px]:w-[300px] max-[830px]:min-h-[300px] max-[720px]:w-[calc(100%_-_20px)]' src={url} />
        </div>
    </div>
  )
}

export default LeftImage
